import { ExerciseType } from "src/sources/enums/exercise-type.enum";
import { MotionEntity } from "src/sources/entities/motion.entity";
import { TagEntity } from "src/sources/entities/tag.entity";

export class ExerciseEntity {
  /**
   * id (string/number): Unique identifier.
   */
  id: number;
  /**
   * title (string): Exercise title.
   */
  title: string;
  /**
   * instructions (string): General exercise instructions.
   */
  instructions: string;
  /**
   * initialState (string): Starting text content.
   */
  initialState: string;
  /**
   * desiredState (string): Expected text content.
   */
  desiredState: string;
  /**
   * difficulty (string): Difficulty level.
   */
  difficulty: string;
  /**
   * tags (string[]): Categorization tags.
   */
  tags: TagEntity[];
  /**
   * motions (Motion[]): Array of motion entities associated with the exercise.
   */
  motions: MotionEntity[];

  /**
   * type (ExerciseType): Exercise type. Can be one of the following: EDITING, NAVIGATION, BOTH.
   */
  type: ExerciseType;

  /**
   * desiredCursorPosition (number): Desired cursor position in the desiredState text content.
   * This only applies to exercises of type NAVIGATION or BOTH.
   */
  desiredCursorPosition?: number;

  constructor(
    id: number,
    title: string,
    instructions: string,
    initialState: string,
    desiredState: string,
    difficulty: string,
    type: ExerciseType,
    desiredCursorPosition?: number
  ) {
    this.id = id;
    this.title = title;
    this.instructions = instructions;
    this.initialState = initialState;
    this.desiredState = desiredState;
    this.difficulty = difficulty;
    this.type = type;
    this.tags = [];
    this.motions = [];
    if (desiredCursorPosition !== undefined) {
      this.desiredCursorPosition = desiredCursorPosition;
    }
  }

  addTag(tag: TagEntity) {
    this.tags.push(tag);
  }

  addTags(tags: TagEntity[]) {
    this.tags.push(...tags);
  }

  addMotion(motion: MotionEntity) {
    this.motions.push(motion);
  }
  addMotions(motions: MotionEntity[]) {
    this.motions.push(...motions);
  }
}
